"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Input wrapper directive, used to stop the compilation of the current element
 * and copy all attributes to the underneath input element.
 *
 * To keep a property on the wrapper, prefix it with "wrapper-*"
 * In example, "wrapper-class" will create the "class" property on the wrapper, where "class" will be copied to the input.
 */
ngModule.directive("tlInputWrapper", function ($compile) {
  // TODO : keep ngShow, ngIf... and other logic directive on the wrapper.
  return {
    restrict: "A",
    priority: 1200,
    terminal: true,
    compile: function compile($el, $attrs) {
      var input = $el.find("input");
      $attrs.$set("tlInputWrapper", null);
      var attributesToKeep = {};
      _.each($attrs.$attr, function (domAttributeName, normalizedAttributeName) {
        if (domAttributeName.indexOf("wrapper-") === 0) {
          attributesToKeep[domAttributeName.substring(8)] = $attrs[normalizedAttributeName];
          $attrs.$set(normalizedAttributeName, null);
        } else {
          input.attr(domAttributeName, $attrs[normalizedAttributeName]);
          $attrs.$set(normalizedAttributeName, null);
        }
      });
      _.each(attributesToKeep, function (attrValue, attrName) {
        $attrs.$set(attrName, attrValue);
      });
      return {
        pre: function pre($scope, $el) {
          $compile($el)($scope);
        },
        post: function post($scope, $el) {
          $el.addClass("tl-input-wrapper");
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/inputs/tl-input-wrapper.js
// module id = 2974
// module chunks = 13